export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '转盘配置';
